import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Typography } from '@mui/material';
import { useTableFilters } from '../context';

const ClearAllButton = () => {
  const { selectedFilters, clearFilters } = useTableFilters();

  return (
    <CustomButton
      buttonType="borderless"
      disabled={!Object.values(selectedFilters).flat().length}
      onClick={clearFilters}
    >
      <Typography variant="bodyDefaultStrong">Clear all</Typography>
    </CustomButton>
  );
};

export default ClearAllButton;
